import React, { useState, useEffect, useContext } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { getJson } from 'session';
import MenuSidebar from 'modules/partials/components/MenuSidebar';
import CmsContext from 'context/CmsContext';
import Header from 'modules/partials/components/Header';
import LogoutContainer from 'modules/auth/containers/LogoutContainer';
import MainDashboardContainer from 'modules/main-dashboard/MainDashboardContainer';
import Announcement from 'modules/announcements/container/AnnouncementContainer';
import ProfileContainer from 'modules/profile/container/ProfileContainer';
import UserManagementContainer from 'modules/user-management/UserManagementContainer';
import CDLContainer from 'modules/CDL/CDLContainer';
import PSAContainer from 'modules/civil-registry/container/PSAContainer';
import RoleManagementContainer from 'modules/role-management/container/RoleManagementContainer';
import OHPContainer from 'modules/OHP/container/OHPContainer';
import SocialAmeliorationContainer from 'modules/social-amelioration-borongan/SocialAmeliorationContainer';
import SubscriberContainer from 'modules/subscribers/container/SubscriberContainer';
import MainCitizenContainer from 'modules/citizens/MainCitizenContainer';
import SettingsContainer from 'modules/general-settings/SettingsContainer';
import RPTApplication from 'modules/RPTB/RPTContainer';
import RPTTransactContainer from 'modules/real-property-tax/RptContainer';
import BillingsContainer from 'modules/billing/BillingsContainer';
import BTAXListingContainer from 'modules/BTAX/container/BTAXListingContainer';
import PCContainer from 'modules/PC/container/PCContainer';
import ReportsContainer from 'modules/reports/ReportsContainer';
import GCashReportsContainer from 'modules/gcash-reports/GCashReportsContainer';
import OVRSContainer from 'modules/OVRS/container/OVRSContainer';
import DeliveryContainer from 'modules/delivery/DeliveryContainer';
import PaymentsContainer from 'modules/payments/PaymentsContainer';
import eBPLSContainer from 'modules/eBPLS/container/eBPLSContainer';
import BPLSContainer from 'modules/BPLS/BPLSContainer';
import NewsContainer from 'modules/news/NewsContainer';
import BillsPaymentContainer from 'modules/ebills/billsPayment/BillsPaymentContainer';
import NOVListingContainer from 'modules/NOV/container/NOVListingContainer';
import EGovernment from 'modules/main-dashboard/container/EGovernment';
import PermissionContainer from 'modules/permissions/container/PermissionContainer';
import { Acl } from 'modules/common/components/Acl';
import SmartCityServicesContainer from 'modules/general-settings/smart-city-services/container/SmartCityServicesContainer';
import EWalletServicesContainer from 'modules/general-settings/e-wallet-services/container/EWalletServicesContainer';
import AccessControlContainer from 'modules/general-settings/AccessControlContainer';
import BillsContainer from 'modules/e-wallet-services/bills/container/BillsContainer';
import CashInContainer from 'modules/e-wallet-services/cash-in/CashInContainer';
import EWalletSupportContainer from 'modules/e-wallet-services/wallet-support/EWalletSupportContainer';
import EWalletServiceContainer from 'modules/e-wallet-services/EWalletServiceContainer';
import CashTransferContainer from 'modules/e-wallet-services/cash-transfer/CashTransferContainer';
import ReceiveFundContainer from 'modules/e-wallet-services/receive-fund/container/ReceiveFundRoutes';
import MobileLoadContainer from 'modules/e-wallet-services/mobile-load/container/MobileLoadContainer';
import Scanner from 'modules/scanner/containers/Scanner';
import EHelpContainer from 'modules/ehelp/EHelpContainer';
import Notifications from 'modules/NOTIFICATIONS/container/NotificationsContainer';
import BPLSReportsContainer from 'modules/bpls-reports/BPLSReportsContainer';
import HealthCertificateContainer from 'modules/health-certificate/HealthCertificateContainer';
import OccupationalPermitContainer from 'modules/OP/container/OccupationalPermitContainer';
import MiscellaneousFeeContainer from 'modules/miscellaneous-fee/MiscellaneousFeeContainer';
import SpecialPermitContainer from 'modules/special-permit/SpecialPermitContainer';
import _ from 'lodash';
import SocialAmeliorationContainers from 'modules/social-amelioration-manila/SocialAmeliorationContainer';
import miscellaneousFeesLPContainer from 'modules/miscellaneous-fee-LP/container/miscellaneousFeesLPContainer';

function PrivateRoutes() {
  const location = useLocation();
  const [isShrinked, setShriken] = useState({ isShrinked: true });
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const [permissions, setPermissions] = useState([]);
  const handleOnShirnked = (value) => {
    setShriken(!value);
  };

  useEffect(() => {
    setPermissions(getJson('permissions'));
  }, []);

  if (location.pathname === '/scanner') {
    return (
      <>
        <Route path="/scanner" component={Scanner} />
      </>
    );
  }

  return (
    <>
      <div className="internal-dashboard">
        <Route
          path="/:mainModule?"
          render={() => <MenuSidebar handleOnShirnked={handleOnShirnked} />}
        />
        {/* <Route
          path="/:mainModule?"
          render={() => <Sidebar handleOnShirnked={handleOnShirnked} />}
        /> */}
        <main className={`main-content${!isShrinked ? ' shrinked' : ''}`}>
          <Header />
          <Switch>
            <Route path="/profile" component={ProfileContainer} />
            <Route path="/logout" component={LogoutContainer} />
            {Acl(permissions, ['VIEW MAIN DASHBOARD']) && (
              <Route exact path="/" component={MainDashboardContainer} />
            )}
            {Acl(permissions, ['VIEW SUBSCRIBERS']) && (
              <Route
                path="/subscribers/:id?/:transaction_type?"
                component={SubscriberContainer}
              />
            )}
            {Acl(permissions, ['VIEW CITIZENS']) && (
              <Route path="/citizens" component={MainCitizenContainer} />
            )}
            {Acl(permissions, ['VIEW E-GOVERNMENT']) && (
              <Route path="/e-government" component={EGovernment} />
            )}

            {Acl(permissions, ['VIEW BPLS']) && (
              <Route path="/bpls" component={BPLSContainer} />
            )}

            {/* Las Piñas */}

            {Acl(permissions, ['VIEW EBPLS APPLICATION']) && (
              <Route path="/ebpls" component={eBPLSContainer} />
            )}

            {Acl(permissions, ['VIEW MISCELLANEOUS FEES LP']) && (
              <Route
                path="/miscellaneous-fee"
                component={miscellaneousFeesLPContainer}
              />
            )}

            {Acl(permissions, ['VIEW CIVIL REGISTRY']) && (
              <Route path="/civil-registry" component={PSAContainer} />
            )}
            {!Acl(permissions, ['VIEW CITIZEN ID']) && (
              <Route path="/citizen-id" component={MainCitizenContainer} />
            )}
            {Acl(permissions, ['VIEW CEDULA']) && (
              <Route path="/cedula" component={CDLContainer} />
            )}
            {Acl(permissions, ['VIEW OCCUPATIONAL AND HEALTH']) && (
              <Route path="/occupational-and-health" component={OHPContainer} />
            )}
            {Acl(permissions, ['VIEW REAL PROPERTY TAX']) && (
              <Route path="/real-property-tax" component={RPTApplication} />
            )}
            {Acl(permissions, ['VIEW REAL PROPERTY TAX']) && (
              <Route path="/business-tax" component={BTAXListingContainer} />
            )}
            {Acl(permissions, ['VIEW POLICE CLEARANCE']) && (
              <Route path="/police-clearance" component={PCContainer} />
            )}
            {Acl(permissions, ['VIEW SOCIAL AMELIORATION']) &&
              _.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan' && (
                <Route
                  path="/social-ameliorations"
                  component={SocialAmeliorationContainer}
                />
              )}
            {Acl(permissions, ['VIEW SOCIAL AMELIORATION']) &&
              _.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                <Route
                  path="/social-ameliorations"
                  component={SocialAmeliorationContainers}
                />
              )}
            {Acl(permissions, ['VIEW BILLINGS']) && (
              <Route path="/billing" component={BillingsContainer} />
            )}
            {Acl(permissions, ['VIEW IMPORTANT NOTIFICATION']) && (
              <Route path="/important-notification" component={Announcement} />
            )}
            {Acl(permissions, ['VIEW NEWS']) && (
              <Route path="/news" component={NewsContainer} />
            )}
            {Acl(permissions, ['VIEW RPT']) && (
              <Route path="/rpt" component={RPTTransactContainer} />
            )}

            {/* TODO: add ACL permission later */}
            {Acl(permissions, ['VIEW E-BILLS']) && (
              <Route path="/e-bills" component={BillsPaymentContainer} />
            )}

            {Acl(permissions, ['VIEW ROLE MANAGEMENT']) && (
              <Route
                path="/role-management"
                component={RoleManagementContainer}
              />
            )}
            {Acl(permissions, ['VIEW PERMISSION']) && (
              <Route
                path="/permission-management"
                component={PermissionContainer}
              />
            )}
            {Acl(permissions, ['VIEW USER MANAGEMENT']) && (
              <Route
                path="/user-management"
                component={UserManagementContainer}
              />
            )}

            <Route path="/delivery" component={DeliveryContainer} />

            {Acl(permissions, ['VIEW GENERAL SETTINGS']) && (
              <Route path="/general-settings" component={SettingsContainer} />
            )}

            {Acl(permissions, ['VIEW ACCESS CONTROL']) && (
              <Route
                path="/general-settings/access-control"
                component={AccessControlContainer}
              />
            )}

            {Acl(permissions, ['VIEW REPORTS']) && (
              <Route path="/reports" component={ReportsContainer} />
            )}

            {Acl(permissions, ['VIEW GCASH REPORTS']) && (
              <Route path="/gcash-reports" component={GCashReportsContainer} />
            )}

            {Acl(permissions, ['VIEW OVRS']) && (
              <Route
                path="/ordinance-violation-receipts"
                component={OVRSContainer}
              />
            )}

            {Acl(permissions, ['VIEW NOV']) && (
              <Route
                path="/notice-of-violations"
                component={NOVListingContainer}
              />
            )}

            {Acl(permissions, ['VIEW PAYMENT MENU']) && (
              <Route path="/payments" component={PaymentsContainer} />
            )}

            {Acl(permissions, [
              'VIEW SMART CITY SERVICES GENERAL SETTINGS',
            ]) && (
              <Route
                path="/smart-city-services"
                component={SmartCityServicesContainer}
              />
            )}

            {Acl(permissions, ['VIEW EWALLET SERVICES GENERAL SETTINGS']) && (
              <Route
                path="/e-wallet-services"
                component={EWalletServicesContainer}
              />
            )}

            {/* <Route path="/e-wallet" component={EWalletServices} /> */}

            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/bills" component={BillsContainer} />
            )}

            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/cash-in" component={CashInContainer} />
            )}

            {Acl(permissions, ['VIEW WALLET SUPPORT']) && (
              <Route
                path="/wallet-support"
                component={EWalletSupportContainer}
              />
            )}
            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/e-wallet" component={EWalletServiceContainer} />
            )}

            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/cash-transfer" component={CashTransferContainer} />
            )}
            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/receive-fund" component={ReceiveFundContainer} />
            )}
            {Acl(permissions, ['VIEW E-WALLET']) && (
              <Route path="/mobile-load" component={MobileLoadContainer} />
            )}
            {Acl(permissions, ['VIEW E-HELP']) && (
              <Route path="/e-help" component={EHelpContainer} />
            )}
            {Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION']) && (
              <Route path="/notifications" component={Notifications} />
            )}
            {/* {Acl(permissions, ['VIEW REPORTS']) && ( */}
            <Route path="/bpls-reports" component={BPLSReportsContainer} />
            <Route
              path="/health-certificate"
              component={HealthCertificateContainer}
            />
            <Route
              path="/occupational-permit"
              component={OccupationalPermitContainer}
            />
            {Acl(permissions, ['VIEW MISCELLANEOUS FEES']) && (
              <Route
                path="/miscellaneous-fees"
                component={MiscellaneousFeeContainer}
              />
            )}
            <Route path="/special-permit" component={SpecialPermitContainer} />
          </Switch>
        </main>
      </div>
    </>
  );
}

export default PrivateRoutes;
